import { render, staticRenderFns } from "./EmployeeNoAuthorizationResidenteField.vue?vue&type=template&id=60b121f4&"
import script from "./EmployeeNoAuthorizationResidenteField.vue?vue&type=script&lang=js&"
export * from "./EmployeeNoAuthorizationResidenteField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports